import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import axios from 'axios'

const baseURL = process.env.REACT_APP_BASE_URL
const fetchDataURL = `${baseURL}/api/auth/get-user-menu`
const changePasswordURL = `${baseURL}/api/account/change-password`

export const fetchData = createAsyncThunk(
  'data/fetchData',
  async (_, { getState, rejectWithValue }) => {
    const state = getState()
    const accessToken = state.auth.accessToken
    try {
      const response = await axios.get(fetchDataURL, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
      })

      return response?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

export const changePassword = createAsyncThunk(
  'data/changepassword',
  async (changePasswordModel, { getState, rejectWithValue }) => {
    const state = getState()
    const accessToken = state.auth.accessToken

    const passwordChangeModel = {
      oldPassword: changePasswordModel.oldPassword,
      newPassword: changePasswordModel.newPassword,
      resetPasswordRequestUniqueId: '',
      otp: '',
    }

    try {
      const response = await axios.put(
        changePasswordURL,
        JSON.stringify(passwordChangeModel),
        {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            'Content-Type': 'application/json',
          },
        }
      )

      return response?.data
    } catch (error) {
      return rejectWithValue(error?.response?.data)
    }
  }
)

const userSlice = createSlice({
  name: 'data',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchData.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchData.fulfilled, (state, action) => {
        state.loading = false
        state.data = action.payload
      })
      .addCase(fetchData.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
      .addCase('RESET', () => ({
        data: null,
        loading: false,
        error: null,
      }))
  },
})

export const selectData = (state) => state.data.data
export const selectLoading = (state) => state.data.loading
export const selectError = (state) => state.data.error

export default userSlice.reducer
